import { ViewModel, View, ObservableArray } from "binder"
import { ToolModelManipulationView } from "./toolModelManipulation-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import { ToolModelEditorViewModel, ToolModelInserter, ToolModelUpdater } from "./toolModelEditor/toolModelEditor-viewModel";
import { IToolModel } from "./IToolModel";

export class ToolModelManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تعریف مدل ابزار';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.toolModels = ObservableArray.create<ToolModel>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

        this.refresh()
    }
    GetDefaultView(): View<ViewModel> {
        return new ToolModelManipulationView();
    }
    public getTypeId(): string {
        return "VM-4EE36374-7FCB-4A25-94D5-D17715AF63CD"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set toolModels(v: ObservableArray<ToolModel>) { this._toolModels = v; } public get toolModels(): ObservableArray<ToolModel> { return this._toolModels; } private _toolModels: ObservableArray<ToolModel>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ToolModelServices/ListAllToolModels', {
                FilteringInformation: filteringInformation
            });
            this.toolModels.update(...result.ToolModels.map((x, i) => {
                let t = new ToolModel(this);
                t.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                t.id = x.Id;
                t.name = x.Name;
                t.code = x.Code;
                t.comment = x.Comment;
                t.toolTypeId = x.ToolTypeId;
                t.toolTypeName = x.ToolTypeName;
                t.toolTypeCode = x.ToolTypeCode;
                t.hasReplacableTool = x.HasReplacableTool;
                return t;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async addNew() {
        let popup = new ToolModelEditorViewModel(this, new ToolModelInserter());
        let result = await this.showPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async edit(toolModel: IToolModel) {
        let popup = new ToolModelEditorViewModel(this, new ToolModelUpdater());
        await toolModel.cloneTo(popup);
        let result = await this.requestShowingPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async remove(toolModel: ToolModel): Promise<void> {
        let isDeleted = await this.messageBoxDangerYesNo('آیا از حذف اطمینان دارید؟', 'حذف');
        if (isDeleted == 'yes') {
            try {
                let result = await ServerConnection.callServer("/Complex/ToolModelServices/DeleteToolModel", {
                    ToolModelId: toolModel.id,
                });
                if (result.IsSuccessful == true) {
                    await this.messageBoxConfirmSuccess("حذف با موفقیت انجام شد", "عملیات موفق");
                    this.dataLoader.refresh();
                } else {
                    if (result.Faults[0].Parameters.FaultId == 'D2BF392F-0EC9-4491-9DD3-FF7F3E096630') {
                        await this.messageBoxConfirmWarning("امکان حذف وجود ندارد", "خطا در عملیات");
                    }
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning("خطا در عملیات حذف", "خطا در عملیات");
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }
}

export class ToolModel extends ViewModel implements IToolModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ToolModelManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: ToolModelManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment; } private _comment: string;
    public set force(v: boolean) { this._force = v; } public get force(): boolean { return this._force; } private _force: boolean;
    public set hasReplacableTool(v: boolean) { this._hasReplacableTool = v; } public get hasReplacableTool(): boolean { return this._hasReplacableTool; } private _hasReplacableTool: boolean;
    public set toolTypeId(v: string) { this._toolTypeId = v; } public get toolTypeId(): string { return this._toolTypeId; } private _toolTypeId: string;
    public set toolTypeName(v: string) { this._toolTypeName = v; } public get toolTypeName(): string { return this._toolTypeName; } private _toolTypeName: string;
    public set toolTypeCode(v: string) { this._toolTypeCode = v; } public get toolTypeCode(): string { return this._toolTypeCode; } private _toolTypeCode: string;

    setToolTypeId(id: string) {
        this.toolTypeId = id;
    }

    getToolTypeId(): string {
        return this.toolTypeId;
    }

    async cloneTo(toolModel: IToolModel) {
        toolModel.id = this.id;
        toolModel.name = this.name;
        toolModel.code = this.code;
        toolModel.comment = this.comment;
        toolModel.hasReplacableTool = this.hasReplacableTool;
        toolModel.setToolTypeId(this.toolTypeId);
    }

    async edit() {
        this._typedParent.edit(this);
    }

    async remove(): Promise<void> {
        this._typedParent.remove(this);
    }
}
